<div class="wrapper">
	<button class="k" on:click="set({ visible: !visible })">K</button>
	{#if visible}
		<div transition:fly='{duration: 3000, ease: quintInOut}'>
			<button on:click="set({ visible2: !visible2 })">evin</button>
		</div>
	{/if}
	<div class="hendelwrap">
		{#if visible2}
		<button class="h" on:click="set({visible3: !visible3 })" transition:fly="{duration: 3000, ease: quintInOut}">H</button>
		{/if}
		{#if visible3}
			<div class="endel" on:click="set({ visible: false, visible2: false, visible3: false })" transition:fly="{duration: 3000, ease: quintInOut}">
				<button>endel</button>
			</div>
		{/if}
	</div>
</div>

<svelte:head>
	<title>K</title>
</svelte:head>

<script>
		import { fly } from 'svelte-transitions';
		import { quintInOut } from 'eases-jsnext';

		export default {
			helpers: { quintInOut },
			transitions: { fly }
		};
	</script>

<style>
	.wrapper {
		padding: 20%
	}

	.k {
		color: palevioletred;
		float: left;
	}

	.hendelwrap {
		width: 300px;
		float: right
	}
	.h {
		float: left;
	}
</style>